import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

i18n
  .use(HttpApi) // Translation files ko /public folder se load karta hai
  .use(initReactI18next) // i18n ko react ke saath connect karta hai
  .init({
    fallbackLng: 'en', // Agar koi language nahi milti toh English use karein
    debug: true, // Console me logs dikhata hai
    interpolation: {
      escapeValue: false, // React pehle se hi XSS se bachata hai
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', // Translation files ka path
    },
  });

export default i18n;